import React from 'react';

const TOTAL_STEPS = 6;

export default function StepIndicator({ current = 0 }) {
  return (
    <div className="flex items-center gap-1.5 justify-center py-4" data-testid="step-indicator">
      {Array.from({ length: TOTAL_STEPS }, (_, i) => (
        <div
          key={i}
          className={`h-1 rounded-full transition-all duration-300 ${
            i <= current
              ? 'bg-[#fbb040] w-8'
              : 'bg-gray-200 w-4'
          }`}
          data-testid={`step-dot-${i}`}
        />
      ))}
    </div>
  );
}
